import useDeviceDetect from 'Hooks/useDeviceDetect';
import { store } from 'Models/Store';
import { useNavigate } from 'react-router-dom';
import { FreightIcon } from '../Icon/IconHelpers';
import { FormattedMessage } from 'react-intl';
import { Button } from 'Views/Components/Button/Button';
import * as React from 'react';
import { trackStartGuidedBooking } from 'Util/_HumanWritten/Analytics/analyticsEvents';
import { TabSelected } from '../BookingWizard/FerryTripBookingWizard/BookingWizardTypes';

export interface FreightBookingButtonProps {
	onSearch: (type: TabSelected) => void;
}

export function FreightBookingButton({ onSearch }: FreightBookingButtonProps) {
	const navigate = useNavigate();

	const { isMobile } = useDeviceDetect();

	const onFreightClick = () => {
		trackStartGuidedBooking('freight');
		onSearch('freight');

		if (isMobile) {
			navigate('/booking-wizard?type=freight');
		} else {
			navigate('/home/search?type=freight');
		}
	};

	return (
		<Button key="freight-booking-button" className="booking-type__button hide-underline" onClick={onFreightClick}>
			<h5>
				<FreightIcon />
				<FormattedMessage id="freight__name__label" defaultMessage="Freight" />
			</h5>
		</Button>
	);
}
